import { SinglePermission } from '../types';

// The route to the Weighted Temperatures module and the Temperatures - ISO pill on the Historical page
export const HISTORICAL_WEIGHTED_TEMPERATURES_PERMISSION: SinglePermission = [
  'Historical',
  'Weighted_Temperatures',
];
